<template>
    <div class="credit-info" >
        Рассрочка <span class="money"><span class="currency">{{displayPrice | money}}</span></span> x {{month}}
        <!-- <tooltip :active="hover">
            <div>Рассрочка 0-0-{{month}}!</div>
            <div>за <span class="currency">{{displayPrice | money}}</span>/мес</div>
        </tooltip> -->
    </div>
</template>

<script>
export default {
    // components: {
    //     tooltip: require('~/components/common/tooltip/').default,
    // },
    // data: () => ({hover: true}),
    props: ['price', 'month'],
    computed: {
        displayPrice() {
            return Math.round((this.price.oldPrice || this.price.price) / this.month);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/colors.scss';
.credit-info {
    border-radius: 6px;
    white-space: nowrap;
    vertical-align: middle;
    margin-right: 20px;
    // position: relative;

    .money {
        display: inline-block;
        background-color: $color-yellow;
        padding: 2px 5px;
        font-weight: 500;
        border-radius: 3px;
    }
}
</style>